module.exports = __webpack_public_path__ + "img/orient.6260ecf5.png";